module.exports = __webpack_public_path__ + "img/demo-student.472a836e.png";